import { Component, Vue } from 'vue-property-decorator';

@Component
export class HhmmssRule extends Vue {
  hhmmssRule(value: string): true | string {
    if (!value) return true;
    return !!value.match(/^[0-9]*:[0-5][0-9]:[0-5][0-9]$/) || 'Falsches Format! (hh:mm:ss)';
  }
}
